__turbopack_context__.v({
  "backButton": "Vtjs4q_backButton",
  "container": "Vtjs4q_container",
  "content": "Vtjs4q_content",
  "contentWrapper": "Vtjs4q_contentWrapper",
  "divider": "Vtjs4q_divider",
  "field": "Vtjs4q_field",
  "form": "Vtjs4q_form",
  "formContent": "Vtjs4q_formContent",
  "full": "Vtjs4q_full",
  "half": "Vtjs4q_half",
  "heading": "Vtjs4q_heading",
  "headingsContainer": "Vtjs4q_headingsContainer",
  "notice": "Vtjs4q_notice",
  "policies": "Vtjs4q_policies",
  "submit": "Vtjs4q_submit",
  "succesImage": "Vtjs4q_succesImage",
  "successContainer": "Vtjs4q_successContainer",
});
